import { ICurbsideHereResponse } from "@ts/components/pages/Curbside/curbside.interface";
import { Util } from "../utils/util";
import { HttpService } from "./http-service";
import { Data } from "../models/data";
import { IService } from "./service.interface";

export class BrandService implements IService {
    private readonly _http: HttpService;
    private readonly _data: Data;
    private readonly _apiBrandUrl: string;
    private readonly _publicKey: string;

    constructor(http: HttpService, data: Data, apiBrandUrl: string, publicKey: string) {
        this._http = http;
        this._data = data;
        this._apiBrandUrl = apiBrandUrl;
        this._publicKey = publicKey;
    }

    public httpRequestAsync(method: string, url: string, payload: object | null = null, options?: { showProgress?: boolean, noCache?: boolean }): Promise<Response> {
        const storeKey = this._data.getProperty("StoreInfo")?.storeKey
            ?? this._data.getBrandProperty("StoreInfo").storeKey;

        const timeOffset = this._data.getProperty("TimeOffset")
            ?? this._data.getBrandProperty("TimeOffset");

        const businessStartMinute = this._data.getProperty("Settings")?.BSM
            ?? this._data.getBrandProperty("Settings").BSM;

        let businessDate = new Date().toISOString();
        try {
            businessDate = Util.GetBUSDate(Util.NowStore(timeOffset), timeOffset, businessStartMinute).toISOString();
        } catch { }

        return this._http.request(method, url, payload, storeKey, businessDate, { showProgress: options?.showProgress, noCache: options?.noCache });
    }

    public curbsideHere = async (data: any): Promise<ICurbsideHereResponse> => {
        const payload = await Util.encrypt(JSON.stringify(data), this._publicKey);
        const response = await this.httpRequestAsync("POST", `${this._apiBrandUrl}curbside-here`, payload);
        const json = response.status === 200 ? await this._http.getJson(response) : null;
        return json ?? { success: false, message: "Curbside_ConfirmationError" };
    };
}
